import React from 'react';
import toast, { resolveValue } from 'react-hot-toast';
import { CheckCircle, XCircle, Info, Loader2, X } from './Icons';

// Teal/dark themed toast with a close button and an auto-dismiss progress bar.
// Rendered for every toast via the <Toaster> render-prop, so existing
// toast.success()/toast.error() call sites need no changes.
const TYPE_META = {
  success: { Icon: CheckCircle, color: '#31C590' },
  error: { Icon: XCircle, color: '#f87171' },
  loading: { Icon: Loader2, color: '#23F8B5' },
  blank: { Icon: Info, color: '#23F8B5' },
};

const CustomToast = ({ t }) => {
  const meta = TYPE_META[t.type] || TYPE_META.blank;
  const Icon = meta.Icon;
  const hasProgress = t.type !== 'loading' && t.duration != null && t.duration !== Infinity;

  return (
    <div
      className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-xl border border-white/10 bg-[#1e2129] shadow-2xl"
      style={{
        opacity: t.visible ? 1 : 0,
        transform: t.visible ? 'translateY(0) scale(1)' : 'translateY(-8px) scale(0.98)',
        transition: 'opacity 220ms ease, transform 220ms ease',
      }}
    >
      <div className="flex items-start gap-3 p-3">
        <Icon
          className={`w-5 h-5 flex-shrink-0 mt-0.5 ${t.type === 'loading' ? 'animate-spin' : ''}`}
          style={{ color: meta.color }}
        />
        <div className="flex-1 min-w-0 text-sm font-medium text-white leading-snug break-words">
          {resolveValue(t.message, t)}
        </div>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="-mr-1 -mt-0.5 flex-shrink-0 rounded-md p-1 text-gray-400 transition-colors hover:bg-white/[0.08] hover:text-white"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      {hasProgress && (
        <div className="h-0.5 w-full bg-white/[0.08]">
          <div
            key={t.id}
            className="h-full"
            style={{
              backgroundColor: meta.color,
              animation: `toastProgress ${t.duration}ms linear forwards`,
              animationPlayState: t.visible ? 'running' : 'paused',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CustomToast;
